export default {
    LOAD_CONTRACT_MODEL(state, contract_model) {
        state.items = contract_model;
    }
}